import { Button } from "@omnabase/ui";
import { weeklyHoursLabel, type DayKey, type WorkingHours } from "@omnabase/shared";
import { DAY_LONG, addBlock, copyToWeekdays, dayOff, fromChoices, removeBlock, setBlockFrom, setBlockTo, toChoices } from "../../lib/teamHours";
import { Pick } from "./Pick";

/** The lines under the hours calendar for the picked day (the hours editor round, 2026-11-02; brief
 *  docs/briefs/discussion-polish-hours-editor-round.md rule 9): one line per block, "From · To · Remove", each picker kept between the block's
 *  neighbours; then "Add hours · Copy to Mon to Fri · Day off" with the weekly total at the right. Pure choices live in `lib/teamHours.ts`. */
export function HoursLines({ day, hours, onChange }: { day: DayKey; hours: WorkingHours; onChange: (hours: WorkingHours) => void }) {
  const blocks = hours.days[day];
  const added = addBlock(hours, day);
  return (
    <div className="ob-hours__lines">
      <strong className="ob-hours__day">{DAY_LONG[day]}</strong>
      {blocks.length === 0 && <p className="ob-hours__line ob-hours__line--block ob-dtable__muted">Day off</p>}
      {blocks.map((b, i) => (
        <div key={i} className="ob-hours__line ob-hours__line--block">
          <Pick label="From" value={b.from} options={fromChoices(hours, day, i)} onChange={(v) => onChange(setBlockFrom(hours, day, i, v))} />
          <span className="ob-dtable__muted">to</span>
          <Pick label="To" value={b.to} options={toChoices(hours, day, i)} onChange={(v) => onChange(setBlockTo(hours, day, i, v))} />
          <Button size="sm" variant="ghost" aria-label={`Remove ${b.from} to ${b.to}`} onClick={() => onChange(removeBlock(hours, day, i))}>Remove</Button>
        </div>
      ))}
      <div className="ob-hours__line">
        <span className="ob-hours__actions">
          <Button size="sm" disabled={!added} onClick={() => added && onChange(added)}>Add hours</Button>
          <Button size="sm" onClick={() => onChange(copyToWeekdays(hours, day))}>Copy to Mon to Fri</Button>
          <Button size="sm" variant="ghost" disabled={!blocks.length} onClick={() => onChange(dayOff(hours, day))}>Day off</Button>
        </span>
        <span className="ob-hours__total">{weeklyHoursLabel(hours)}</span>
      </div>
    </div>
  );
}
